import { FocusEstateNewsInstanceWithPic } from './focusAPI';
import { HttpResult } from '../API';

export interface FocusEstateNewsInstanceWithPic {
    link: string,
    resource_map: {
        pic_text: {
            url: string,                                      // pic url
            despriction: string,                              // title
        },
    },
}

export interface FocusEstateNewsInstanceWithPureText {
    link: string,
    resource_map: {
        text: {
            despriction: string,                              // title
        },
    },
}

export interface FocusEstateNewsInstance {
    link: string,
    content: {
        title: string,
        picUrl?: string,
    }
}

export interface FocusEstateNewsAPIBody {
    code: number,
    message: string,
    data: {
        list: Array<FocusEstateNewsInstanceWithPic | FocusEstateNewsInstanceWithPureText>,
    },
}

export interface FocusEstateNewsAPI extends HttpResult {
    body: FocusEstateNewsAPIBody
}

export const isFocusEstateNewsWithPic = (obj: FocusEstateNewsInstanceWithPic | FocusEstateNewsInstanceWithPureText): obj is FocusEstateNewsInstanceWithPic => {
    return typeof (obj.resource_map as any).pic_text !== 'undefined';
};



// WEBPACK FOOTER //
// ./src/models/apis/focusAPI.ts